import { useSetRecoilState } from 'recoil'
import { playgroundAtom } from './playgroundStore'
const usePlaygroundAtomFunction = () => {
    const setPlayground = useSetRecoilState(playgroundAtom)

    const setFirstName = (value: string) => {
        setPlayground((prevState) => ({
            ...prevState,
            profile: {
                ...prevState.profile,
                firstName: `${value}`,
            },
        }))
    }

    return {
        setFirstName,
    }
}

export default usePlaygroundAtomFunction
